import React from 'react';
import { RouteProps } from 'react-router-dom';
import { colors } from '../../src/Constants/constants';
import LanguageIcon from '@material-ui/icons/Language';
import {
	makeStyles,
	Theme,
	createStyles,
	useTheme,
	useMediaQuery,
	List,
	Drawer,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
	Link,
	withStyles,
	Divider,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { routes } from '../Routing/routes';
import { CorporationsIcon, DevicesIcon, UserIcon, GppGoodOutlinedIcon } from './Components/Icons';
import AppLink from './Components/AppLink';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';

const drawerWidth = 300;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
		},
		drawerPaper: {
			width: drawerWidth,
		},
		toolBarProperties: {
			toolbar: theme.mixins.toolbar,
			minHeight: '90px',
		},
		appVersionInfo: {
			position: 'absolute',
			bottom: 0,
		},
		icon: {
			fill: '#999999',
		},
		listItem: {
			paddingLeft: '30px',
		},
		listItemIcon: {
			paddingLeft: '5px',
		},
	})
);

interface Props {
	isOpen: boolean;
	handleDrawerToggle: () => void;
}

const StyledListItemText = withStyles({
	primary: {
		color: 'black',
	},
})(ListItemText);

const ApplicationDrawer: React.FC<Props & RouteProps> = (props) => {
	const classes = useStyles(props);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const { t } = useTranslation();

	const menuElements = [
		{ title: t('menu.location'), url: routes.locations, icon: <CorporationsIcon /> },
		{ title: t('menu.devices'), url: routes.devices, icon: <DevicesIcon /> },
		{ title: t('menu.users'), url: routes.users, icon: <UserIcon /> },
		{ title: t('menu.graphics'), url: routes.graphics, icon: <CropOriginalIcon className={classes.icon} /> },
		{ title: t('menu.goals'), url: routes.goals, icon: <GppGoodOutlinedIcon /> },
		{ title: t('menu.rules'), url: routes.rules, icon: <AssignmentOutlinedIcon className={classes.icon} /> },
	];

	const drawerMenu = (() => {
		return (
			<List>
				{menuElements.map((item, index) => {
					return (
						<AppLink to={item.url} key={index}>
							<ListItem
								style={{
									background:
										document.location.pathname === item.url ||
										(item.url === routes.locations && document.location.pathname === routes.root)
											? colors.barPanelSelectItemColor
											: '',
								}}
								className={classes.listItem}
								button
							>
								<ListItemIcon className={classes.listItemIcon}>{item.icon}</ListItemIcon>
								<StyledListItemText primary={item.title} />
							</ListItem>
						</AppLink>
					);
				})}
			</List>
		);
	})();

	return (
		<Drawer
			className={classes.drawer}
			open={props.isOpen}
			onClose={props.handleDrawerToggle}
			variant={isMobile ? 'temporary' : 'permanent'}
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			<div className={classes.toolBarProperties} />
			{drawerMenu}

			<Divider />

			<List className={classes.appVersionInfo}>
				<ListItem className={classes.listItem}>
					<ListItemIcon className={classes.listItemIcon}>{<LanguageIcon />}</ListItemIcon>
					<ListItemText>
						<Typography variant='body2' color='textSecondary'>
							&copy; {`${new Date().getFullYear()} `}
							<Link href='https://lbpro.net' target='a_blank' style={{ color: colors.main }}>
								LBPRO
							</Link>
						</Typography>
					</ListItemText>
				</ListItem>
			</List>
		</Drawer>
	);
};

export default ApplicationDrawer;
